import { render, staticRenderFns } from "./RodadasCompraExistentes.vue?vue&type=template&id=532f4dbd&scoped=true"
import script from "./RodadasCompraExistentes.vue?vue&type=script&setup=true&lang=js"
export * from "./RodadasCompraExistentes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RodadasCompraExistentes.vue?vue&type=style&index=0&id=532f4dbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f4dbd",
  null
  
)

export default component.exports